import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconBlend({
  isAutoscallable = true,
  sizeKey = '22x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8757 7.3329C16.3228 6.19944 11.97 2.56211 11.97 2.56211C11.4865 2.15328 10.7637 2.21378 10.3553 2.69686C9.94603 3.17994 10.0065 3.90273 10.4896 4.31157L12.9765 6.41623H4.35482C3.72186 6.41623 3.20899 6.92911 3.20899 7.56207C3.20899 8.19502 3.72186 8.7079 4.35482 8.7079H8.3822L0.907237 14.4449C0.405362 14.8303 0.310487 15.5494 0.695946 16.0513C0.921446 16.3456 1.26153 16.4996 1.60574 16.4996C1.84911 16.4996 2.09432 16.4226 2.30286 16.2626L6.88436 12.7463C6.88299 12.7994 6.87565 12.8503 6.87565 12.9035C6.87565 16.4863 9.86949 19.2496 13.7507 19.2496C17.6318 19.2496 20.9314 16.4863 20.9314 12.9035C20.9314 10.6673 19.6522 8.62998 17.8757 7.3329Z"
        fill="url(#paint0_linear_3685_63664)"
      />
      <path
        d="M13.9785 16.5C16.4465 16.5 18.4473 14.6532 18.4473 12.375C18.4473 10.0968 16.4465 8.25 13.9785 8.25C11.5105 8.25 9.50977 10.0968 9.50977 12.375C9.50977 14.6532 11.5105 16.5 13.9785 16.5Z"
        fill="white"
      />
      <path
        opacity="0.07"
        d="M13.9792 8.24967C16.4473 8.24967 18.4479 10.0963 18.4479 12.3747C18.4479 14.653 16.4473 16.4997 13.9792 16.4997C11.511 16.4997 9.51042 14.653 9.51042 12.3747C9.51042 10.0963 11.511 8.24967 13.9792 8.24967ZM13.9792 8.02051C11.3887 8.02051 9.28125 9.97392 9.28125 12.3747C9.28125 14.7754 11.3887 16.7288 13.9792 16.7288C16.5697 16.7288 18.6771 14.7754 18.6771 12.3747C18.6771 9.97392 16.5697 8.02051 13.9792 8.02051Z"
        fill="black"
      />
      <path
        opacity="0.05"
        d="M13.9798 8.02116C16.5703 8.02116 18.6777 9.97458 18.6777 12.3753C18.6777 14.7761 16.5703 16.7295 13.9798 16.7295C11.3893 16.7295 9.2819 14.7761 9.2819 12.3753C9.2819 9.97458 11.3893 8.02116 13.9798 8.02116ZM13.9798 7.79199C11.2628 7.79199 9.05273 9.84808 9.05273 12.3753C9.05273 14.9026 11.2628 16.9587 13.9798 16.9587C16.6968 16.9587 18.9069 14.9026 18.9069 12.3753C18.9069 9.84808 16.6968 7.79199 13.9798 7.79199Z"
        fill="black"
      />
      <path
        d="M13.9798 14.6663C15.372 14.6663 16.5007 13.6403 16.5007 12.3747C16.5007 11.109 15.372 10.083 13.9798 10.083C12.5876 10.083 11.459 11.109 11.459 12.3747C11.459 13.6403 12.5876 14.6663 13.9798 14.6663Z"
        fill="#0370C8"
      />
      <path
        opacity="0.05"
        d="M13.9792 9.85417C15.4953 9.85417 16.7292 10.9849 16.7292 12.375C16.7292 13.7651 15.4953 14.8958 13.9792 14.8958C12.463 14.8958 11.2292 13.7651 11.2292 12.375C11.2292 10.9849 12.463 9.85417 13.9792 9.85417ZM13.9792 9.625C12.3365 9.625 11 10.8588 11 12.375C11 13.8912 12.3365 15.125 13.9792 15.125C15.6218 15.125 16.9583 13.8912 16.9583 12.375C16.9583 10.8588 15.6218 9.625 13.9792 9.625Z"
        fill="black"
      />
      <path
        opacity="0.07"
        d="M13.9785 10.0837C15.3709 10.0837 16.4993 11.1099 16.4993 12.3753C16.4993 13.6408 15.3709 14.667 13.9785 14.667C12.5861 14.667 11.4577 13.6408 11.4577 12.3753C11.4577 11.1099 12.5861 10.0837 13.9785 10.0837ZM13.9785 9.85449C12.4623 9.85449 11.2285 10.9852 11.2285 12.3753C11.2285 13.7655 12.4623 14.8962 13.9785 14.8962C15.4947 14.8962 16.7285 13.7655 16.7285 12.3753C16.7285 10.9852 15.4947 9.85449 13.9785 9.85449Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3685_63664"
          x1="0.458987"
          y1="10.7704"
          x2="20.9314"
          y2="10.7704"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA402" />
          <stop offset="1" stopColor="#FF8800" />
        </linearGradient>
      </defs>
    </svg>
  );
}
